/**
 * FASE 4.5 — Warning assuntivi (informativi, non bloccanti).
 *
 * Calcolati sulla base del form_data D&O (o Cyber, dove applicabile).
 * Le compagnie richiederanno maggiore attenzione su questi punti in fase
 * di sottoscrizione ma NON bloccano l'invio.
 */

export function computeAssuntiviWarnings(formData) {
  const w = [];
  const struttura = formData?.struttura || {};
  const geografia = formData?.geografia || {};
  const operazioni = formData?.operazioni || {};
  const sinistri = formData?.sinistri || {};
  const storia = formData?.storia_assic || {};
  const bilanci = formData?.bilanci || {};

  if (struttura.quotata_borsa_italiana) {
    w.push({ text: "Società quotata in borsa italiana", severity: "warn" });
  }
  if (struttura.quotata_estero) {
    const paesi = struttura.quotata_estero_paesi;
    w.push({
      text: paesi ? `Quotazione estera (${paesi})` : "Quotazione estera",
      severity: "warn",
    });
  }
  if (struttura.quotata_mercato_ristretto) {
    w.push({ text: "Quotata al mercato ristretto", severity: "warn" });
  }
  if (geografia.controllate_usa_canada) {
    w.push({ text: "Presenza controllate in USA/Canada", severity: "warn" });
  }
  if (struttura.soggetta_controllo_corte_conti) {
    w.push({ text: "Soggetta a controllo Corte dei Conti / enti pubblici", severity: "warn" });
  }
  if (struttura.capogruppo) {
    w.push({ text: "Capogruppo / gruppo societario", severity: "info" });
  }
  if (operazioni.operazioni_5anni_si_no) {
    w.push({ text: "Acquisizioni/fusioni negli ultimi 5 anni", severity: "warn" });
  }
  if (operazioni.operazioni_programmate_si_no) {
    w.push({ text: "Acquisizioni/fusioni/OPA programmate", severity: "warn" });
  }
  if (storia.certificazione_bilanci) {
    w.push({ text: "Bilanci certificati da società di revisione", severity: "info" });
  }
  if (sinistri.sinistri_presenti) {
    w.push({ text: "Sinistri o richieste pregresse", severity: "warn" });
  }
  if (sinistri.conoscenza_circostanze) {
    w.push({ text: "Conoscenza di circostanze rilevanti (3.3)", severity: "warn" });
  }
  if (operazioni.riduzione_personale_si_no) {
    w.push({ text: "Piani di ristrutturazione / licenziamenti", severity: "warn" });
  }
  if (operazioni.pignoramenti_si_no) {
    w.push({ text: "Pignoramenti / esecuzioni forzate", severity: "critical" });
  }
  if (operazioni.procedure_concorsuali_si_no) {
    w.push({
      text: "ATTENZIONE: la presenza di procedure concorsuali potrebbe pregiudicare l'assunzione della polizza. L'agenzia verificherà con le compagnie.",
      severity: "critical",
    });
  }
  if (bilanci.perdita_oltre_20pct_pn_si_no) {
    w.push({ text: "Perdita > 20% patrimonio netto", severity: "critical" });
  }
  return w;
}

/**
 * Detect placeholder tipici lato client (allineati al backend detector).
 * Ritorna [{path, value, reason}, ...]
 */
const PLACEHOLDER_EXACT = new Set([
  "test_finale", "test_finale_all_si",
  "mario rossi", "luigi bianchi", "anna verdi",
  "via roma 1", "via roma 2", "via test 1",
  "12345678901", "12345678903", "1234567890", "0000000000",
  "example.com", "test@example.com", "test.com", "fake.com", "test.it",
  "asd", "asdf", "asdasd",
]);

const PLACEHOLDER_PATTERNS = [
  /\btest[_\-\s]?finale\b/i,
  /\btest[_\-\s]?complete\b/i,
  /\blorem\s+ipsum\b/i,
  /\bfake[_\-\s]?data\b/i,
  /@(example|test|fake|demo|dummy)\.(com|it|org|net|io)\b/i,
  /^12345(6(7(89?0?1?)?)?)?$/,
  /^(a{5,}|x{5,}|z{5,}|q{5,})$/i,
  /^(test|demo|prova|sample)\d*$/i,
];

function _checkPlaceholderStr(s) {
  if (!s || typeof s !== "string") return null;
  const trimmed = s.trim();
  if (!trimmed) return null;
  if (PLACEHOLDER_EXACT.has(trimmed.toLowerCase())) {
    return `placeholder esatto '${trimmed}'`;
  }
  for (const pat of PLACEHOLDER_PATTERNS) {
    if (pat.test(trimmed)) {
      return `pattern placeholder ${pat.source}`;
    }
  }
  return null;
}

const _INTERNAL_KEYS = new Set(["_test_mode", "_placeholder_flags"]);

export function findPlaceholders(formData, path = "") {
  const out = [];
  if (formData === null || formData === undefined) return out;
  if (Array.isArray(formData)) {
    formData.forEach((item, i) =>
      out.push(...findPlaceholders(item, `${path}[${i}]`))
    );
  } else if (typeof formData === "object") {
    for (const [k, v] of Object.entries(formData)) {
      if (_INTERNAL_KEYS.has(k)) continue;
      const newPath = path ? `${path}.${k}` : k;
      out.push(...findPlaceholders(v, newPath));
    }
  } else if (typeof formData === "string") {
    const reason = _checkPlaceholderStr(formData);
    if (reason) {
      out.push({
        path,
        value: formData.trim().slice(0, 40),
        reason,
      });
    }
  }
  return out;
}
